import type { CPInputConfiguration, ExtendedBlock, ListView, RepeatableContainer } from 'widget-components'
import validators from '../validators'
import { useI18n } from '@/composables/i18n'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const validateBlockValue = (block: ExtendedBlock, skipEmpty: boolean, _currentValue?: any) => {
    const currentValue = _currentValue || block.currentValue
    const { t } = useI18n()

    // skip if is empty and user is still filling form
    if (skipEmpty && currentValue === '') {
        return ''
    }

    // skip empty not-required values
    if (currentValue === '' && !(block as ExtendedBlock<CPInputConfiguration>).required) {
        return ''
    }

    let error

    const blockValidator = (block as ExtendedBlock<CPInputConfiguration>).validator

    // validate blocks
    if (blockValidator && blockValidator in validators) {
        const validator = validators[blockValidator as keyof typeof validators]

        error = validator.validate(currentValue as string)
            ? undefined
            : t(validator.message)
    }

    return error
}

export const validateBlock = (_block: ExtendedBlock, skipEmpty = true): void => {
    if (_block.type === 'LIST_VIEW') {
        const block = _block as ExtendedBlock<ListView>

        for (let index = 0; index < block.items.length; index++) {
            const item = block.items[index]

            for (let innerIndex = 0; innerIndex < item.components.length; innerIndex++) {
                const innerBlock = item.components[innerIndex]
                block.items[index].components[innerIndex].error = validateBlockValue(
                    innerBlock,
                    skipEmpty,
                    block.currentValue[index]?.[innerIndex],
                )
            }
        }
    }

    if (_block.type === 'REPEATABLE_CONTAINER') {
        const block = _block as ExtendedBlock<RepeatableContainer>
        for (let index = 0; index < block.children.length; index++) {
            const item = block.children[index]

            for (let innerIndex = 0; innerIndex < item.length; innerIndex++) {
                const innerBlock = item[innerIndex]
                block.children[index][innerIndex].error = validateBlockValue(
                    innerBlock,
                    skipEmpty,
                    block.currentValue[index]?.[innerIndex],
                )
            }
        }
    }

    _block.error = validateBlockValue(_block, skipEmpty)
}
